module.exports = __webpack_public_path__ + "media/images/ohap__Gradebook_Options-754415a92a291c99ab837fe083778476.png";